import { render, staticRenderFns } from "./oss-file.vue?vue&type=template&id=76a89519&scoped=true"
import script from "./oss-file.vue?vue&type=script&lang=js"
export * from "./oss-file.vue?vue&type=script&lang=js"
import style0 from "./oss-file.vue?vue&type=style&index=0&id=76a89519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a89519",
  null
  
)

export default component.exports